import { AutocompleteInput } from 'react-admin';
import { useState, useMemo } from 'react';
import { useInfiniteAutocomplete } from '../../../hooks/useInfiniteAutocomplete';

export const PdfAutoCompleteInput = (props: any) => {
    const [selectedItem, setSelectedItem] = useState<any>(null);

    const {
        choices: fetchedChoices,
        isLoading,
        setSearchText,
        handleScroll,
    } = useInfiniteAutocomplete('pdfs', {
        baseFilter: { deleted: false },
        searchField: 'title',
    });

    const choices = useMemo(() => {
        const dataArray = fetchedChoices || [];
        if (selectedItem && !dataArray.find((item: any) => item.id === selectedItem.id)) {
            return [selectedItem, ...dataArray];
        }
        return dataArray;
    }, [fetchedChoices, selectedItem]);

    return (
        <AutocompleteInput
            {...props}
            source={props.source || 'pdfId'}
            fullWidth
            label="Pdf"
            choices={choices}
            optionText="title"
            optionValue="id"
            loading={isLoading}
            setFilter={value => setSearchText(value)}
            onChange={value => {
                const selected = choices.find((item: any) => item.id === value);
                if (selected) {
                    setSelectedItem(selected);
                }
                if (props.onChange) {
                    props.onChange(value);
                }
            }}
            debounce={500}
            shouldRenderSuggestions={(val: string) => {
                return val.trim().length >= 0;
            }}
            ListboxProps={{ onScroll: handleScroll }}
        />
    );
};
